"use strict";

var _interopRequireDefault = require("D:/work/code/aihuz/arbitration-ui/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regeneratorRuntime2 = _interopRequireDefault(require("D:/work/code/aihuz/arbitration-ui/node_modules/@babel/runtime/helpers/regeneratorRuntime.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("D:/work/code/aihuz/arbitration-ui/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
var _trial = require("@/api/trial.js");
var _security = require("@/utils/security");
var _encryptKey = require("@/config/encryptKey");
var _viewMixin = _interopRequireDefault(require("@/views/trial/components/mixins/viewMixin.js"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// import "mui-player/dist/mui-player.min.css";
// import MuiPlayer from "mui-player";
var _default = {
  mixins: [_viewMixin.default],
  data: function data() {
    return {
      req: {
        reqPage: _trial.audioNoticePage,
        reqInsert: _trial.audioNoticeInsert,
        reqUpdate: _trial.audioNoticeUpdate,
        reqDelete: _trial.audioNoticeDelete
      },
      title: "音频公告",
      tableHeaderColor: this.$tableHeaderColor,
      stateArr: [{
        //状态数组
        value: "1",
        label: "已启用"
      }, {
        value: "0",
        label: "已禁用"
      }],
      titlevalue: "",
      statevalue: "",
      //状态值
      form: {
        title: "",
        audioPath: "",
        state: "",
        audioHref: ""
      },
      formRules: {
        title: [{
          required: true,
          message: "请输入标题名"
        }],
        audioPath: [{
          required: true,
          message: "请输入"
        }],
        state: [{
          required: true,
          message: "请选择"
        }]
      },
      // base_api: process.env.VUE_APP_BASE_API,
      uploadUrl: process.env.VUE_APP_BASE_API + "/trial/file-record/uploadFile",
      fileList: [],
      headers: {
        Authorization: localStorage.getItem("token")
      }
    };
  },
  created: function created() {},
  watch: {
    form: function form(val, old) {
      if (document.getElementById("audio-path")) {
        var audioPath = document.getElementById("audio-path");
        console.log(val);
        audioPath.src = val.audioHref;
      }
    }
  },
  methods: {
    getData: function () {
      var _getData = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee() {
        var page,
          data,
          _args = arguments;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              page = _args.length > 0 && _args[0] !== undefined ? _args[0] : null;
              data = {};
              if (this.statevalue != "") {
                data["state"] = this.statevalue;
              }
              if (this.titlevalue != "") {
                data["title"] = this.titlevalue;
              }
              _context.next = 6;
              return this.getList(page, data);
            case 6:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function getData() {
        return _getData.apply(this, arguments);
      }
      return getData;
    }(),
    handleThisCreate: function handleThisCreate() {
      this.fileList = [];
      this.handleCreate();
    },
    handleThisUpdate: function handleThisUpdate(val) {
      // var mp = new MuiPlayer({
      //   container: "#mui-player",
      //   initFullFixed: false,
      //   height: 30,
      //   src:
      //     "https://aihuz-bucket-dev.oss-cn-shenzhen.aliyuncs.com/trial_video_file/472508266249981952/001.mp3?Expires=1685167120&OSSAccessKeyId=LTAIzAA2V6v16hAo&Signature=SbA33b6xdc2o7diZw4fZgALrCH4%3D"
      // });
      this.fileList = [];
      this.handleUpdate(val);
    },
    handleDialogClose: function handleDialogClose() {
      if (document.getElementById("audio-path")) {
        var audioPath = document.getElementById("audio-path");
        audioPath.pause();
      }
    },
    clearAllConditon: function clearAllConditon() {
      this.statevalue = "";
      this.titlevalue = "";
      this.getData(1);
    },
    handleUploadSuccess: function handleUploadSuccess(res, file) {
      var _this = this;
      var response = JSON.parse((0, _security.decryptByAES)(res.response, _encryptKey.encryptKey.key));
      console.log(response);
      this.form.audioPath = response.data.filePath;
      if (response.code == 1) {
        this.$nextTick(function () {
          console.log(document.getElementById("audio-path"));
          if (document.getElementById("audio-path")) {
            // let audioPath = document.getElementById("audio-path");
            document.getElementById("audio-path").src = response.data.aliyunOssHref;
          }
        });
      } else {
        // location.reload();
        this.$notify({
          title: "提示",
          message: "上传失败"
        });
      }
    },
    handleUploadRemove: function handleUploadRemove() {
      this.fileList = [];
      this.form.audioPath = "";
    },
    handleUploadChange: function handleUploadChange(file) {
      // this.form.audioPath = "";
      this.fileList = [];
      this.fileList.push(file);
    }
  },
  mounted: function mounted() {
    this.getData(1);
  }
};
exports.default = _default;